import React from "react"
import styles from "./index-main.scss"

const Legal = () => (
  <div className={styles["r-legal"]}>
    <div className="r-legal__banner">
      <div className="inner"></div>
    </div>
    <div className="r-legal__content">
      <div className="header">协议及声明</div>
      <div className="menus clearfix">
        <ul className="menus-col">
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/aboutus.html"
              target="_blank"
            >
              关于我们
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/contact.html"
              target="_blank"
            >
              联系我们
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/career.html"
              target="_blank"
            >
              加入我们
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/terms.html"
              target="_blank"
            >
              用户服务协议
            </a>
          </li>
        </ul>
        <ul className="menus-col">
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/probity.html"
              target="_blank"
            >
              廉政举报
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/privacy.html"
              target="_blank"
            >
              隐私政策
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/app-auth-detail.html"
              target="_blank"
            >
              法律声明
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/license.html"
              target="_blank"
            >
              营业执照
            </a>
          </li>
        </ul>
        <ul className="menus-col">
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/app-auth-detail.html"
              target="_blank"
            >
              权限明细
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/app-third-share.html"
              target="_blank"
            >
              共享个人信息
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/intellectual.html"
              target="_blank"
            >
              知识产权
            </a>
          </li>
          <li
            className="item"
            data-click={JSON.stringify({
              event: "bottominformation-pagebottom_click",
              content: { expand: { tag_value: "公司介绍" } }
            })}
          >
            <a
              href="https://sta.renrenche.com/legal/release-rules.html"
              target="_blank"
            >
              商品信息发布规则
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default Legal

Legal.getInitialProps = async ({ ctx }) => {
  // ctx.store.dispatch({ type: "SET_BASE_INFO", data: { show_header: true } })
  ctx.store.dispatch({ type: "SET_BASE_INFO", data: { show_footer: false } })
}
